/**
 * fitting-quiz.js
 * SurfaceMaxx Pressure Washer Fitting Finder Quiz — v2
 *
 * Depends on (must load first):
 *   fitting-quiz-data.js  →  window.FQ_FITTINGS, window.FQ_PRODUCTS, window.FQ_RULES
 *
 * Mount: <div id="fq-root"></div>
 * Config: window.FQ_CONFIG (set by fitting-quiz.liquid)
 */

(function () {
  'use strict';

  // =========================================================================
  // CONFIG
  // =========================================================================
  var CFG = Object.assign({
    heading:        'What Fitting Do I Need?',
    intro:          "Answer a few quick questions and we'll show you exactly which fitting connects your equipment.",
    startLabel:     'Find My Fitting',
    supportMsg:     'Still not sure? Our team knows pressure washer fittings inside and out.',
    supportUrl:     '/pages/contact',
    supportLabel:   'Contact Us',
    mountId:        'fq-root',
  }, window.FQ_CONFIG || {});

  // =========================================================================
  // DATA
  // =========================================================================
  var FITTINGS = window.FQ_FITTINGS || {};
  var PRODUCTS  = window.FQ_PRODUCTS  || [];
  var RULES     = window.FQ_RULES     || [];

  // =========================================================================
  // ICON REGISTRY
  // Replace placeholder URLs with actual uploaded Shopify CDN URLs.
  // Format: upload SVG/PNG to Shopify Files, paste URL here.
  // =========================================================================
  var FQ_ICONS = {
    // Connection context icons (SVG)
    'ctx-pump_to_hose':       'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-pump-to-hose_svg.svg?v=1773435373',
    'ctx-hose_to_gun':        'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-hose-to-gun_svg.svg?v=1773435372',
    'ctx-gun_to_wand':        'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-gun-to-wand_svg.svg?v=1773435372',
    'ctx-wand_to_attachment': 'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-wand-to-attachment_svg.svg?v=1773435373',
    'ctx-hose_to_hose':       'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/hose_to_hose.svg?v=1773436318',
    'ctx-diagnose':           'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-hose-to-hose_svg.svg?v=1773435372',

    // Product type icons (PNG)
    'pt-pressure_washer':              'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-pressure-washer.png?v=1773436060',
    'pt-high_pressure_hose':           'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-hose.png?v=1773436060',
    'pt-spray_gun':                    'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-spray-gun.png?v=1773436060',
    'pt-wand':                         'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-wand.png?v=1773436060',
    'pt-surface_cleaner':              'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-surface-cleaner.png?v=1773436060',
    'pt-foam_cannon':                  'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-foam-cannon.png?v=1773436060',
    'pt-nozzle':                       'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-nozzle.png?v=1773436060',
    'pt-attachment':                   'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-attachment.png?v=1773436060',
    'pt-garden_hose':                  'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-garden-hose.png?v=1773436061',
    'pt-nothing_yet':                  'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-nothing-yet.png?v=1773436060',
    'pt-extension_wand':               'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-extension-wand.png?v=1773436060',
    'pt-walk_behind_surface_cleaner':  'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-walk-behind-surface-cleaner.png?v=1773436060',

    // Diagnostic attachment icons (reuse product type icons where applicable)
    'da-foam_cannon':                  'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-foam-cannon.png?v=1773436060',
    'da-surface_cleaner':              'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-surface-cleaner.png?v=1773436060',
    'da-walk_behind_surface_cleaner':  'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-walk-behind-surface-cleaner.png?v=1773436060',
    'da-turbo_nozzle':                 'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-nozzle.png?v=1773436060',
    'da-nozzle':                       'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-nozzle.png?v=1773436060',
    'da-new_gun':                      'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-spray-gun.png?v=1773436060',
    'da-new_hose':                     'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-hose.png?v=1773436060',
    'da-new_wand':                     'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-wand.png?v=1773436060',
    'da-extension_wand':               'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-extension-wand.png?v=1773436060',
    'da-gutter':                       'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-attachment.png?v=1773436060',
    'da-undercarriage':                'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-attachment.png?v=1773436060',
    'da-other':                        'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-attachment.png?v=1773436060',
    'da-new_to_pw':                    'https://cdn.shopify.com/s/files/1/0895/7820/9568/files/fq-icon-nothing-yet.png?v=1773436060',
  };

  // =========================================================================
  // STATIC DATA SETS
  // =========================================================================

  var CONNECTION_CONTEXTS = [
    { id: 'pump_to_hose',       label: 'Pressure Washer → Hose',   emoji: '🔧', sub: 'Connect pump outlet to high-pressure hose' },
    { id: 'hose_to_gun',        label: 'Hose → Spray Gun',         emoji: '💧', sub: 'Connect hose end to trigger gun inlet' },
    { id: 'gun_to_wand',        label: 'Spray Gun → Wand',         emoji: '🔫', sub: 'Connect gun outlet to wand or lance' },
    { id: 'wand_to_attachment', label: 'Wand → Attachment',        emoji: '⚙️',  sub: 'Foam cannon, surface cleaner, nozzle, etc.' },
    { id: 'hose_to_hose',       label: 'Hose → Hose',              emoji: '🔗', sub: 'Extend or join two hoses together' },
    { id: 'diagnose',           label: 'Not listed/Help Me Figure it out', emoji: '🔍', sub: "Not sure where to start? We'll walk you through it.", diagnose: true },
  ];

  var PRODUCT_TYPES = [
    { id: 'pressure_washer',            label: 'Pressure Washer',            emoji: '🔧', sub: 'Gas or electric pressure washer' },
    { id: 'high_pressure_hose',         label: 'High-Pressure Hose',         emoji: '🟠', sub: 'The hose between pump and gun' },
    { id: 'spray_gun',                  label: 'Spray Gun',                  emoji: '🔫', sub: 'Trigger gun / handle' },
    { id: 'wand',                       label: 'Wand / Lance',               emoji: '📏', sub: 'Short wand or included lance' },
    { id: 'extension_wand',             label: 'Extension Wand (9 or 18 ft)',emoji: '📐', sub: 'SurfaceMaxx telescoping extension wand' },
    { id: 'surface_cleaner',            label: 'Surface Cleaner',            emoji: '🧹', sub: 'Handheld rotating disc cleaner' },
    { id: 'walk_behind_surface_cleaner',label: 'Walk-Behind Surface Cleaner',emoji: '🚶', sub: 'Large walk-behind disc for driveways & patios' },
    { id: 'foam_cannon',                label: 'Foam Cannon',                emoji: '🫧', sub: 'Snow foam / soap cannon attachment' },
    { id: 'nozzle',                     label: 'Nozzle / Tip',               emoji: '💨', sub: 'Color-coded spray tip or turbo nozzle' },
    { id: 'attachment',                 label: 'Other Attachment',           emoji: '🔩', sub: 'Gutter wand, undercarriage cleaner, etc.' },
    { id: 'garden_hose',                label: 'Garden Hose',                emoji: '🌿', sub: 'Standard garden hose (GHT thread)' },
  ];

  // What diagnostic attachment is the customer trying to use?
  var DIAG_ATTACHMENTS = [
    { id: 'foam_cannon',                label: 'Foam Cannon / Snow Foam Lance',     emoji: '🫧', sub: 'The bottle that makes thick soap foam' },
    { id: 'surface_cleaner',            label: 'Surface Cleaner (handheld)',        emoji: '🧹', sub: 'Rotating disc — you hold the wand' },
    { id: 'walk_behind_surface_cleaner',label: 'Walk-Behind Surface Cleaner',       emoji: '🚶', sub: 'Large rolling disc for driveways & big surfaces' },
    { id: 'turbo_nozzle',               label: 'Turbo / Rotary Nozzle',            emoji: '💨', sub: 'Spinning nozzle tip for tough cleaning' },
    { id: 'nozzle',                     label: 'Spray Nozzle Tips',                emoji: '🎯', sub: 'Color-coded fan nozzles (0°, 15°, 25°, 40°, soap)' },
    { id: 'new_gun',                    label: 'New Spray Gun',                    emoji: '🔫', sub: 'Replacing or upgrading my trigger gun' },
    { id: 'new_hose',                   label: 'New / Longer Hose',               emoji: '🟠', sub: 'Replacing or extending my high-pressure hose' },
    { id: 'new_wand',                   label: 'New Wand / Lance',                emoji: '📏', sub: 'Short wand or included lance replacement' },
    { id: 'extension_wand',             label: 'Extension Wand (9 or 18 ft)',      emoji: '📐', sub: 'SurfaceMaxx telescoping extension wand' },
    { id: 'gutter',                     label: 'Gutter Cleaning Kit',              emoji: '🏠', sub: 'Curved wand for cleaning gutters' },
    { id: 'undercarriage',              label: 'Undercarriage Cleaner',            emoji: '🚗', sub: 'Flat rotating cleaner for under vehicles' },
    { id: 'other',                      label: 'Something Else',                  emoji: '🔩', sub: 'An attachment not listed above' },
    { id: 'new_to_pw',                  label: "I'm New to Pressure Washing",      emoji: '👋', sub: "I don't know what I need yet", coaching: true },
  ];

  // What equipment do they currently own? (multi-select)
  var DIAG_EQUIPMENT = [
    { id: 'pressure_washer',    label: 'A Pressure Washer',                emoji: '🔧', sub: 'Gas or electric' },
    { id: 'spray_gun',          label: 'A Spray Gun',                      emoji: '🔫', sub: 'Trigger gun / handle' },
    { id: 'high_pressure_hose', label: 'A High-Pressure Hose',             emoji: '🟠', sub: 'The orange or gray hose from the pump' },
    { id: 'wand',               label: 'A Wand / Lance',                   emoji: '📏', sub: 'The straight metal tube' },
    { id: 'nothing_yet',        label: 'None of the Above / Starting Fresh',emoji: '📦', sub: "I'm setting up for the first time" },
  ];

  var FITTING_OPTIONS_BY_PRODUCT = {
    pressure_washer:             ['m22_14_male','m22_15_male','npt_3_8_male','npt_3_8_female','qc_3_8_plug','proprietary','unknown'],
    high_pressure_hose:          ['m22_14_female','m22_15_female','m22_14_male','npt_3_8_male','qc_3_8_coupler','qc_3_8_plug','unknown'],
    spray_gun:                   ['m22_14_male','m22_15_male','m22_14_female','npt_3_8_female','qc_3_8_plug','qc_1_4_coupler','proprietary','unknown'],
    wand:                        ['qc_1_4_plug','m22_14_male','m22_15_male','npt_1_4_male','npt_3_8_male','qc_1_4_coupler','proprietary','unknown'],
    extension_wand:              ['qc_1_4_plug','m22_14_male','m22_15_male','npt_1_4_male','npt_3_8_male','unknown'],
    surface_cleaner:             ['qc_1_4_plug','m22_14_male','m22_15_male','npt_1_4_male','unknown'],
    walk_behind_surface_cleaner: ['qc_1_4_plug','m22_14_male','npt_1_4_male','unknown'],
    foam_cannon:                 ['qc_1_4_plug','m22_14_female','npt_1_4_male','npt_1_4_female','unknown'],
    nozzle:                      ['qc_1_4_plug','npt_1_4_male','unknown'],
    attachment:                  ['qc_1_4_plug','m22_14_male','npt_1_4_male','npt_3_8_male','unknown'],
    garden_hose:                 ['ght_3_4_male','ght_3_4_female','unknown'],
    default:                     Object.keys(FITTINGS),
  };

  // Maps each standard context to its deterministic product types (skips Steps 2 & 4)
  var CONTEXT_PRODUCT_MAP = {
    pump_to_hose:       { have_type: 'pressure_washer',  want_type: 'high_pressure_hose' },
    hose_to_gun:        { have_type: 'high_pressure_hose', want_type: 'spray_gun' },
    gun_to_wand:        { have_type: 'spray_gun',         want_type: 'wand' },
    wand_to_attachment: { have_type: 'wand',              want_type: 'attachment' },
    hose_to_hose:       { have_type: 'high_pressure_hose', want_type: 'high_pressure_hose' },
  };

  // Human-readable labels for the progress bar context display
  var CONTEXT_LABELS = {
    pump_to_hose:       'Pump → Hose',
    hose_to_gun:        'Hose → Spray Gun',
    gun_to_wand:        'Spray Gun → Wand',
    wand_to_attachment: 'Wand → Attachment',
    hose_to_hose:       'Hose → Hose',
    diagnose:           'Fitting Diagnostic',
  };

  // QC sets to recommend on direct_fit results (keyed by fitting combination)
  // SGY-PWA78 = new 4500 PSI QC kit; others are existing sets
  var QC_UPSELL_BY_CONTEXT = {
    pump_to_hose:       ['SGY-PWA10', 'SGY-PWA6', 'SGY-PWA78'],
    hose_to_gun:        ['SGY-PWA10', 'SGY-PWA6', 'SGY-PWA78'],
    gun_to_wand:        ['SGY-PWA3',  'SGY-PWA98'],
    wand_to_attachment: ['SGY-PWA3'],
    hose_to_hose:       ['SGY-PWA10', 'SGY-PWA6'],
  };

  // =========================================================================
  // STATE
  // =========================================================================
  /*
   * Main quiz state:
   *   screen:        'intro' | 'step' | 'diagnose' | 'result'
   *   step:          1-5  (used when screen='step')
   *   context:       string|null
   *   have_type:     string|null
   *   have_fitting:  string|null
   *   want_type:     string|null
   *   want_fitting:  string|null
   *
   * Diagnostic sub-state (used when screen='diagnose'):
   *   diag_step:      1-4
   *   diag_attachment: string|null  (what they want to connect)
   *   diag_equipment:  string[]     (what they currently have)
   */
  var state = buildInitialState();

  function buildInitialState() {
    return {
      screen:          'intro',
      step:            1,
      context:         null,
      have_type:       null,
      have_fitting:    null,
      want_type:       null,
      want_fitting:    null,
      // diagnostic
      diag_step:       1,
      diag_attachment: null,
      diag_equipment:  [],
    };
  }

  // =========================================================================
  // ENTRY POINT
  // =========================================================================
  function init() {
    var root = document.getElementById(CFG.mountId);
    if (!root) { console.warn('[FittingQuiz] #' + CFG.mountId + ' not found.'); return; }
    render(root);
  }

  // =========================================================================
  // MAIN RENDER DISPATCHER
  // =========================================================================
  function render(root) {
    root.innerHTML = '';
    var wrapper = el('div', { className: 'fq-quiz' });

    if      (state.screen === 'intro')   wrapper.appendChild(renderIntro());
    else if (state.screen === 'step')    wrapper.appendChild(renderStep());
    else if (state.screen === 'diagnose') wrapper.appendChild(renderDiagnose());
    else if (state.screen === 'result')  wrapper.appendChild(renderResult());

    root.appendChild(wrapper);

    // Toggle intro-screen class on parent section so CSS can show/hide .fitting-quiz-section__intro
    var section = root.closest('.fitting-quiz-section') || root.parentElement;
    if (section) {
      if (state.screen === 'intro') {
        section.classList.add('fq-quiz--intro-screen');
      } else {
        section.classList.remove('fq-quiz--intro-screen');
      }
    }
  }

  function rerender() {
    var root = document.getElementById(CFG.mountId);
    if (root) render(root);
  }

  // =========================================================================
  // INTRO SCREEN
  // =========================================================================
  function renderIntro() {
    var div = el('div', { className: 'fq-intro' });

    div.appendChild(el('span', { className: 'fq-intro__eyebrow', textContent: 'Fitting Finder' }));
    div.appendChild(el('h2',  { className: 'fq-intro__heading',  textContent: CFG.heading }));
    div.appendChild(el('p',   { className: 'fq-intro__body',     textContent: CFG.intro }));

    var btn = el('button', { className: 'fq-btn fq-btn--start', textContent: CFG.startLabel });
    btn.addEventListener('click', function() { state.screen = 'step'; state.step = 1; rerender(); });
    div.appendChild(btn);
    return div;
  }

  // =========================================================================
  // STANDARD QUIZ STEPS
  // =========================================================================
  function renderStep() {
    var wrap = el('div', { className: 'fq-step' });
    wrap.appendChild(renderProgressBar(state.step, 5));

    switch (state.step) {
      case 1: wrap.appendChild(renderStep1()); break;
      case 2: wrap.appendChild(renderStep2()); break;
      case 3: wrap.appendChild(renderStep3()); break;
      case 4: wrap.appendChild(renderStep4()); break;
      case 5: wrap.appendChild(renderStep5()); break;
    }
    return wrap;
  }

  // Step 1 — What are you trying to connect?
  function renderStep1() {
    var wrap = el('div');
    wrap.appendChild(renderStepHeader(
      'What are you trying to connect?',
      'Pick the two ends you\'re working with. Not sure? Choose "Help Me Figure It Out."'
    ));

    var grid = el('div', { className: 'fq-choice-grid' });
    CONNECTION_CONTEXTS.forEach(function(ctx) {
      var isDiagnose = ctx.diagnose;
      var isSelected = state.context === ctx.id;
      var card = el('div', {
        className: 'fq-choice-card' +
          (isDiagnose ? ' fq-choice-card--diagnose' : '') +
          (isSelected ? ' is-selected' : ''),
        role: 'button', tabIndex: 0,
      });

      // Icon — use uploaded image if available, fall back to emoji
      var iconUrl = FQ_ICONS['ctx-' + ctx.id];
      if (iconUrl) {
        var imgWrap = el('div', { className: 'fq-choice-card__img-wrap' });
        imgWrap.appendChild(el('img', { className: 'fq-choice-card__img', src: iconUrl, alt: ctx.label, loading: 'lazy' }));
        card.appendChild(imgWrap);
      } else {
        card.appendChild(el('span', { className: 'fq-choice-card__icon', textContent: ctx.emoji }));
      }

      card.appendChild(el('span', { className: 'fq-choice-card__label', textContent: ctx.label }));
      card.appendChild(el('span', { className: 'fq-choice-card__sub',   textContent: ctx.sub }));

      function go() {
        state.context = ctx.id;
        if (ctx.diagnose) {
          state.screen    = 'diagnose';
          state.diag_step = 1;
        } else {
          // Standard context — pre-fill product types and skip Steps 2 & 4
          var ctxMap = CONTEXT_PRODUCT_MAP[ctx.id];
          if (ctxMap) {
            state.have_type    = ctxMap.have_type;
            state.want_type    = ctxMap.want_type;
            state.have_fitting = null;
            state.want_fitting = null;
            state.step = 3; // jump directly to "What fitting is on your X?"
          } else {
            state.step = 2;
          }
        }
        rerender();
      }
      card.addEventListener('click', go);
      card.addEventListener('keydown', function(e) { if (e.key==='Enter'||e.key===' ') go(); });
      grid.appendChild(card);
    });

    wrap.appendChild(grid);
    wrap.appendChild(renderNav(null, null));
    return wrap;
  }

  // Step 2 — What product do you have?
  function renderStep2() {
    var wrap = el('div');
    wrap.appendChild(renderStepHeader(
      'What product do you already have?',
      'Choose the item that has the fitting you\'re starting from.'
    ));
    wrap.appendChild(renderProductGrid(
      'have',
      function(ptId) { state.have_type = ptId; state.have_fitting = null; state.step = 3; rerender(); }
    ));
    wrap.appendChild(renderNav(
      function() { state.step = 1; rerender(); }, null
    ));
    return wrap;
  }

  // Step 3 — What fitting is on your product?
  function renderStep3() {
    var wrap = el('div');
    wrap.appendChild(renderStepHeader(
      'What fitting is on your ' + getProductLabel(state.have_type) + '?',
      'Look at the end you\'re trying to connect. Pick the one that matches.'
    ));
    wrap.appendChild(renderGenderHelper());
    var fids = getFittingsForProduct(state.have_type);
    wrap.appendChild(renderFittingGrid(fids, state.have_fitting, function(fid) {
      state.have_fitting = fid;
      state.want_fitting = null;
      // Skip step 4 if want_type already determined by context
      if (state.want_type && CONTEXT_PRODUCT_MAP[state.context]) {
        state.step = 5;
      } else {
        state.want_type = null;
        state.step      = 4;
      }
      rerender();
    }));
    // Back: if context preset want_type, go back to step 1; otherwise step 2
    var backFn = CONTEXT_PRODUCT_MAP[state.context]
      ? function() { state.step = 1; rerender(); }
      : function() { state.step = 2; rerender(); };
    wrap.appendChild(renderNav(backFn, null));
    return wrap;
  }

  // Step 4 — What do you want to connect to?
  function renderStep4() {
    var wrap = el('div');
    wrap.appendChild(renderStepHeader(
      'What do you want to connect it to?',
      'Choose the other item — the one you\'re trying to attach.'
    ));
    wrap.appendChild(renderProductGrid(
      'want',
      function(ptId) { state.want_type = ptId; state.want_fitting = null; state.step = 5; rerender(); }
    ));
    wrap.appendChild(renderNav(function() { state.step = 3; rerender(); }, null));
    return wrap;
  }

  // Step 5 — What fitting is on the second product?
  function renderStep5() {
    var wrap = el('div');
    wrap.appendChild(renderStepHeader(
      'What fitting is on your ' + getProductLabel(state.want_type) + '?',
      'Look at the end you\'re trying to connect to. Pick the closest match.'
    ));
    wrap.appendChild(renderGenderHelper());
    var fids = getFittingsForProduct(state.want_type);
    wrap.appendChild(renderFittingGrid(fids, state.want_fitting, function(fid) {
      state.want_fitting = fid;
      state.screen       = 'result';
      rerender();
    }));
    // Back: if want_type was pre-filled by context, go to step 3; otherwise step 4
    var step5BackFn = CONTEXT_PRODUCT_MAP[state.context]
      ? function() { state.step = 3; rerender(); }
      : function() { state.step = 4; rerender(); };
    wrap.appendChild(renderNav(step5BackFn, null));
    return wrap;
  }

  // =========================================================================
  // DIAGNOSTIC FLOW  ("Help Me Figure It Out")
  // =========================================================================
  /*
   * diag_step 1 — "What are you trying to use / add?"  (attachment type)
   * diag_step 2 — "What do you already have?"           (equipment checklist)
   * diag_step 3 — Coaching + narrowed recommendation    (PW 101 + resolved path)
   * diag_step 4 — if resolved: jump into step 3/4 of normal quiz
   */
  function renderDiagnose() {
    var wrap = el('div', { className: 'fq-step' });

    // Progress shows "Diagnostic" track, 3 sub-steps
    wrap.appendChild(renderProgressBar(state.diag_step, 3, 'Fitting Diagnostic'));

    if      (state.diag_step === 1) wrap.appendChild(renderDiagStep1());
    else if (state.diag_step === 2) wrap.appendChild(renderDiagStep2());
    else if (state.diag_step === 3) wrap.appendChild(renderDiagStep3());

    return wrap;
  }

  // Diagnostic Step 1 — What are you trying to connect / use?
  function renderDiagStep1() {
    var wrap = el('div');
    wrap.appendChild(renderStepHeader(
      'What are you trying to use or connect?',
      'Select the product or attachment you\'re working with.'
    ));

    var grid = el('div', { className: 'fq-choice-grid' });
    DIAG_ATTACHMENTS.forEach(function(da) {
      var isSelected = state.diag_attachment === da.id;
      var card = el('div', {
        className: 'fq-choice-card' + (isSelected ? ' is-selected' : ''),
        role: 'button', tabIndex: 0,
      });

      var iconUrl = FQ_ICONS['da-' + da.id];
      if (iconUrl) {
        var iw = el('div', { className: 'fq-choice-card__img-wrap' });
        iw.appendChild(el('img', { className: 'fq-choice-card__img', src: iconUrl, alt: da.label, loading: 'lazy' }));
        card.appendChild(iw);
      } else {
        card.appendChild(el('span', { className: 'fq-choice-card__icon', textContent: da.emoji }));
      }

      card.appendChild(el('span', { className: 'fq-choice-card__label', textContent: da.label }));
      card.appendChild(el('span', { className: 'fq-choice-card__sub',   textContent: da.sub }));

      function go() {
        state.diag_attachment = da.id;
        // "New to pressure washing" gets extra coaching
        if (da.coaching) {
          state.diag_step = 2;
        } else {
          state.diag_step = 2;
        }
        rerender();
      }
      card.addEventListener('click', go);
      card.addEventListener('keydown', function(e) { if(e.key==='Enter'||e.key===' ') go(); });
      grid.appendChild(card);
    });

    wrap.appendChild(grid);
    wrap.appendChild(renderNav(
      function() { state.screen = 'step'; state.step = 1; state.context = null; rerender(); },
      null
    ));
    return wrap;
  }

  // Diagnostic Step 2 — What equipment do you have right now?
  function renderDiagStep2() {
    var wrap = el('div');

    var isNewToPW = state.diag_attachment === 'new_to_pw';

    wrap.appendChild(renderStepHeader(
      isNewToPW
        ? "Let's start from the beginning — what do you have right now?"
        : 'What do you currently have to connect it to?',
      isNewToPW
        ? "Select everything you already own. If you're starting from nothing, that's okay too."
        : 'Check everything you have on hand right now.'
    ));

    // Pressure Washing 101 for new customers
    if (isNewToPW) {
      wrap.appendChild(renderPW101Panel());
    }

    var checklist = el('div', { className: 'fq-checklist' });
    DIAG_EQUIPMENT.forEach(function(item) {
      var isChecked = state.diag_equipment.indexOf(item.id) !== -1;
      var row = el('div', {
        className: 'fq-check-item' + (isChecked ? ' is-checked' : ''),
        role: 'checkbox',
        tabIndex: 0,
      });
      row.setAttribute('aria-checked', isChecked ? 'true' : 'false');

      var box = el('div', { className: 'fq-check-item__box' });
      row.appendChild(box);

      var iconUrl = FQ_ICONS['pt-' + item.id];
      if (iconUrl) {
        var iw = el('div', { className: 'fq-choice-card__img-wrap' });
        iw.style.cssText = 'width:32px;height:32px;flex-shrink:0;';
        iw.appendChild(el('img', { src: iconUrl, alt: item.label, loading: 'lazy', style: 'width:100%;height:100%;object-fit:contain;' }));
        row.appendChild(iw);
      } else {
        row.appendChild(el('span', { className: 'fq-check-item__icon', textContent: item.emoji }));
      }

      var textDiv = el('div', { className: 'fq-check-item__text' });
      textDiv.appendChild(el('div', { className: 'fq-check-item__label', textContent: item.label }));
      textDiv.appendChild(el('div', { className: 'fq-check-item__sub',   textContent: item.sub }));
      row.appendChild(textDiv);

      function toggle() {
        var idx = state.diag_equipment.indexOf(item.id);
        // "nothing_yet" is exclusive
        if (item.id === 'nothing_yet') {
          state.diag_equipment = (idx === -1) ? ['nothing_yet'] : [];
        } else {
          // Remove "nothing_yet" if selecting something real
          state.diag_equipment = state.diag_equipment.filter(function(e) { return e !== 'nothing_yet'; });
          if (idx === -1) state.diag_equipment.push(item.id);
          else            state.diag_equipment.splice(idx, 1);
        }
        rerender();
      }
      row.addEventListener('click', toggle);
      row.addEventListener('keydown', function(e) { if(e.key==='Enter'||e.key===' ') toggle(); });

      checklist.appendChild(row);
    });

    wrap.appendChild(checklist);

    var canContinue = state.diag_equipment.length > 0;
    var nextBtn = el('button', {
      className: 'fq-btn fq-btn--primary',
      textContent: 'See My Recommendation →',
    });
    if (!canContinue) nextBtn.setAttribute('disabled', 'true');
    nextBtn.addEventListener('click', function() {
      if (canContinue) { state.diag_step = 3; rerender(); }
    });

    var nav = el('div', { className: 'fq-nav' });
    nav.appendChild(el_btn('← Back', 'fq-btn fq-btn--ghost', function() {
      state.diag_step = 1; rerender();
    }));
    nav.appendChild(nextBtn);
    nav.appendChild(renderResetBtn());
    wrap.appendChild(nav);
    return wrap;
  }

  // Diagnostic Step 3 — Coaching + resolved recommendation
  function renderDiagStep3() {
    var wrap = el('div');
    var resolved = resolveDiagnosticPath();

    wrap.appendChild(renderStepHeader(
      resolved.heading,
      resolved.subheading
    ));

    // Always show the full setup chain for orientation
    wrap.appendChild(renderSetupChainPanel(resolved.highlightStep));

    // Coaching content specific to attachment
    var coachingPanel = getAttachmentCoachingPanel(state.diag_attachment, state.diag_equipment);
    if (coachingPanel) wrap.appendChild(coachingPanel);

    // If we can resolve to a specific compatible connection automatically
    if (resolved.canJumpToContext) {
      // Show a "proceed to quiz" CTA that pre-fills context and skips step 1
      var proceed = el('div', { className: 'fq-install-block' });
      proceed.appendChild(el('div', { className: 'fq-install-block__label', textContent: '🎯 Ready to find your specific fitting?' }));
      var proceedText = el('p', { className: 'fq-install-block__text' });
      proceedText.textContent = resolved.jumpPrompt;
      proceed.appendChild(proceedText);

      var jumpBtn = el('button', { className: 'fq-btn fq-btn--primary', textContent: resolved.jumpLabel });
      jumpBtn.style.marginTop = '0.75rem';
      jumpBtn.addEventListener('click', function() {
        // Pre-fill state and jump to appropriate quiz step
        state.context      = resolved.context;
        state.have_type    = resolved.have_type || null;
        state.have_fitting = null;
        state.want_type    = resolved.want_type || null;
        state.want_fitting = null;
        state.screen       = 'step';
        state.step         = resolved.have_type ? 3 : 2;
        rerender();
      });
      proceed.appendChild(jumpBtn);
      wrap.appendChild(proceed);
    }

    // Products that are likely relevant to show
    if (resolved.likely_skus && resolved.likely_skus.length > 0) {
      var prods = getProductsBySkus(resolved.likely_skus);
      if (prods.length > 0) {
        var header = el('div', { className: 'fq-step-header', style: 'margin-top:1.5rem;' });
        header.appendChild(el('h3', { className: 'fq-step-header__question', textContent: '🔩 Products likely relevant to your setup:' }));
        wrap.appendChild(header);
        wrap.appendChild(renderProductList(prods, null));
      }
    }

    var nav = el('div', { className: 'fq-result__actions' });
    nav.appendChild(el_btn('← Back', 'fq-btn fq-btn--ghost', function() {
      state.diag_step = 2; rerender();
    }));
    nav.appendChild(renderResetBtn());
    wrap.appendChild(nav);
    wrap.appendChild(renderSupportBlock());
    return wrap;
  }

  // =========================================================================
  // DIAGNOSTIC HELPERS
  // =========================================================================

  /**
   * Resolve what the diagnostic should recommend based on attachment + equipment.
   * Returns a resolved path object.
   */
  function resolveDiagnosticPath() {
    var att  = state.diag_attachment;
    var equip = state.diag_equipment;
    var hasGun  = equip.indexOf('spray_gun') !== -1;
    var hasHose = equip.indexOf('high_pressure_hose') !== -1;
    var hasWand = equip.indexOf('wand') !== -1;
    var hasPW   = equip.indexOf('pressure_washer') !== -1;
    var hasNone = equip.indexOf('nothing_yet') !== -1;

    // Default fallback
    var resolved = {
      heading:          "Here's how your setup connects",
      subheading:       'Based on what you told us, here\'s what you need to know.',
      highlightStep:    null,
      canJumpToContext: false,
      context:          null,
      have_type:        null,
      want_type:        null,
      jumpPrompt:       '',
      jumpLabel:        'Find My Fitting →',
      likely_skus:      [],
    };

    if (att === 'new_to_pw' || hasNone) {
      resolved.heading        = "Here's how a pressure washer system goes together";
      resolved.subheading     = "All the pieces and how they connect — start here.";
      resolved.canJumpToContext = false;
      return resolved;
    }

    // Foam cannon / surface cleaner / turbo nozzle — post-gun accessories
    if (att === 'foam_cannon' || att === 'surface_cleaner' || att === 'turbo_nozzle' || att === 'nozzle') {
      resolved.highlightStep  = 'wand_to_attachment';
      if (hasWand) {
        resolved.heading        = 'Your ' + getAttachmentLabel(att) + ' connects to your wand';
        resolved.subheading     = "Most wands use a 1/4\" QC coupler at the tip. Your " + getAttachmentLabel(att).toLowerCase() + " should have a 1/4\" QC plug.";
        resolved.canJumpToContext = true;
        resolved.context        = 'wand_to_attachment';
        resolved.have_type      = 'wand';
        resolved.want_type      = getProductTypeForAttachment(att);
        resolved.jumpPrompt     = "Let's confirm your wand's fitting and your " + getAttachmentLabel(att).toLowerCase() + "'s fitting to find any adapter you might need.";
        resolved.jumpLabel      = 'Check My Wand Fitting →';
        resolved.likely_skus    = ['SMX-PWA315', 'SMX-PWA304'];
      } else if (hasGun) {
        resolved.heading        = 'Connect your ' + getAttachmentLabel(att) + ' to your spray gun';
        resolved.subheading     = "If your gun has a 1/4\" QC coupler outlet, your " + getAttachmentLabel(att).toLowerCase() + " can attach directly — or via a short adapter.";
        resolved.canJumpToContext = true;
        resolved.context        = 'gun_to_wand';
        resolved.have_type      = 'spray_gun';
        resolved.jumpPrompt     = "Let's confirm your gun's outlet fitting.";
        resolved.jumpLabel      = 'Check My Gun Fitting →';
        resolved.likely_skus    = ['SMX-PWA315', 'SMX-PWA304', 'SGY-PWA3'];
      } else if (hasPW) {
        resolved.heading        = 'You need a full hose + gun setup first';
        resolved.subheading     = "Your " + getAttachmentLabel(att).toLowerCase() + " goes at the end of the chain. You'll need a hose and gun between the washer and the attachment.";
        resolved.canJumpToContext = false;
        resolved.likely_skus    = ['SGY-PWA10', 'SGY-PWA27'];
      } else {
        resolved.heading        = 'Your ' + getAttachmentLabel(att) + ' needs a full pressure washer setup';
        resolved.subheading     = "To use a " + getAttachmentLabel(att).toLowerCase() + " you'll need: a pressure washer, hose, and spray gun. Then your attachment connects to the gun outlet or wand.";
      }
      return resolved;
    }

    // New gun
    if (att === 'new_gun') {
      resolved.highlightStep  = 'hose_to_gun';
      if (hasHose) {
        resolved.heading        = 'Connecting a new gun to your hose';
        resolved.subheading     = "Check both the hose end and your new gun's inlet — most use M22 or 3/8\" QC.";
        resolved.canJumpToContext = true;
        resolved.context        = 'hose_to_gun';
        resolved.have_type      = 'high_pressure_hose';
        resolved.want_type      = 'spray_gun';
        resolved.jumpPrompt     = "Let's check both fitting ends to confirm compatibility.";
        resolved.jumpLabel      = 'Check My Hose & Gun Fittings →';
        resolved.likely_skus    = ['SGY-PWA25', 'SGY-PWA30', 'SGY-PWA26', 'SGY-PWA27'];
      } else if (hasPW) {
        resolved.heading        = 'You\'ll need a hose between your washer and gun';
        resolved.subheading     = "Check your pump's outlet fitting first — that determines what hose end you need.";
        resolved.canJumpToContext = true;
        resolved.context        = 'pump_to_hose';
        resolved.have_type      = 'pressure_washer';
        resolved.jumpPrompt     = "Let's start with your pump's fitting.";
        resolved.jumpLabel      = 'Check My Pump Fitting →';
        resolved.likely_skus    = ['SGY-PWA10', 'SGY-PWA26'];
      } else {
        resolved.heading        = 'Starting a new gun setup';
        resolved.subheading     = "A gun needs a hose to connect to your pressure washer. Let's work through the chain.";
      }
      return resolved;
    }

    // New hose
    if (att === 'new_hose') {
      resolved.highlightStep  = 'pump_to_hose';
      resolved.heading        = 'Connecting a new hose to your system';
      resolved.subheading     = "Hoses have fittings on both ends. The pump end usually differs from the gun end.";
      if (hasPW) {
        resolved.canJumpToContext = true;
        resolved.context        = 'pump_to_hose';
        resolved.have_type      = 'pressure_washer';
        resolved.jumpPrompt     = "Let's check your pump's outlet fitting first — that determines the hose end you need.";
        resolved.jumpLabel      = 'Check My Pump Fitting →';
        resolved.likely_skus    = ['SGY-PWA10', 'SGY-PWA6', 'SGY-PWA26', 'SGY-PWA27'];
      }
      return resolved;
    }

    // New wand / lance
    if (att === 'new_wand') {
      resolved.highlightStep  = 'gun_to_wand';
      if (hasGun) {
        resolved.heading        = 'Connecting a new wand to your spray gun';
        resolved.subheading     = "Most spray guns have a 1/4\" QC coupler on the front outlet. Most wands have a 1/4\" QC plug at the base.";
        resolved.canJumpToContext = true;
        resolved.context        = 'gun_to_wand';
        resolved.have_type      = 'spray_gun';
        resolved.want_type      = 'wand';
        resolved.jumpPrompt     = "Let's confirm your gun's outlet fitting.";
        resolved.jumpLabel      = 'Check My Gun Outlet Fitting →';
        resolved.likely_skus    = ['SGY-PWA3', 'SMX-PWA316', 'SMX-PWA300'];
      } else {
        resolved.heading        = 'A wand connects between your gun and attachments';
        resolved.subheading     = "Wands connect to the front of a spray gun. Tell us about your gun to find the right connection.";
      }
      return resolved;
    }

    // Gutter / undercarriage / other
    if (att === 'gutter' || att === 'undercarriage' || att === 'other') {
      resolved.highlightStep  = 'wand_to_attachment';
      resolved.heading        = 'Connecting a specialty attachment';
      resolved.subheading     = "Most specialty attachments use a 1/4\" QC plug at the base and connect to a wand or gun outlet.";
      if (hasWand) {
        resolved.canJumpToContext = true;
        resolved.context        = 'wand_to_attachment';
        resolved.have_type      = 'wand';
        resolved.want_type      = 'attachment';
        resolved.jumpPrompt     = "Let's confirm your wand tip fitting and the attachment's fitting.";
        resolved.jumpLabel      = 'Check My Wand & Attachment Fittings →';
        resolved.likely_skus    = ['SMX-PWA315', 'SMX-PWA304', 'SMX-PWA317'];
      }
      return resolved;
    }

    return resolved;
  }

  function getAttachmentLabel(attId) {
    var da = DIAG_ATTACHMENTS.find(function(d) { return d.id === attId; });
    return da ? da.label : 'Attachment';
  }

  function getProductTypeForAttachment(attId) {
    var map = {
      foam_cannon:    'foam_cannon',
      surface_cleaner:'surface_cleaner',
      turbo_nozzle:   'nozzle',
      nozzle:         'nozzle',
      new_gun:        'spray_gun',
      new_hose:       'high_pressure_hose',
      new_wand:       'wand',
      gutter:         'attachment',
      undercarriage:  'attachment',
      other:          'attachment',
    };
    return map[attId] || 'attachment';
  }

  function getAttachmentCoachingPanel(attId, equipment) {
    // M22 confusion note for hose/gun replacements
    if (attId === 'new_hose' || attId === 'new_gun') {
      return renderCoachingPanel(
        '⚠️',
        'Watch Out: M22-14mm vs M22-15mm',
        '<strong>M22-14mm and M22-15mm look almost identical</strong> but have a 1mm bore difference that makes them incompatible. ' +
        'Most gas pressure washers and aftermarket hoses use <strong>M22-14mm</strong>. ' +
        '<strong>Sun Joe, AR Blue Clean, and Portland</strong> budget electric washers often use <strong>M22-15mm</strong>. ' +
        'Check your washer\'s manual or measure the bore diameter before buying.'
      );
    }
    if (attId === 'foam_cannon') {
      return renderCoachingPanel(
        '💡',
        'Foam Cannon Connection Tip',
        'Most foam cannons ship with a <strong>1/4\" QC plug</strong> at the base and connect to a 1/4\" QC coupler — usually on your wand or gun outlet. ' +
        'Some foam cannons use an <strong>M22 thread</strong> instead. Check your cannon\'s base before ordering an adapter.'
      );
    }
    if (attId === 'new_to_pw' || equipment.indexOf('nothing_yet') !== -1) {
      return renderCoachingPanel(
        '📚',
        'Quick Pressure Washer Setup Guide',
        '<strong>Here\'s the standard setup chain, from water source to cleaning:</strong><br><br>' +
        '1. <strong>Garden hose</strong> (your water supply) → pressure washer INLET (GHT 3/4\" female) — low pressure only<br>' +
        '2. <strong>Pressure washer OUTLET</strong> → high-pressure hose → spray gun → wand → nozzle<br><br>' +
        '<strong>Common connection types:</strong><br>' +
        '• Pump to hose: usually M22-14mm (gas) or M22-15mm (some electrics)<br>' +
        '• Hose to gun: M22 thread or upgraded to 3/8\" QC snap-connect<br>' +
        '• Gun to wand: almost always 1/4\" QC snap-connect<br>' +
        '• Wand to attachment: 1/4\" QC snap-connect (the post-gun standard)'
      );
    }
    return null;
  }

  function renderCoachingPanel(icon, title, bodyHtml) {
    var panel = el('div', { className: 'fq-coaching' });
    var header = el('div', { className: 'fq-coaching__header' });
    header.appendChild(el('span', { className: 'fq-coaching__header-icon', textContent: icon }));
    header.appendChild(el('span', { className: 'fq-coaching__header-title', textContent: title }));
    panel.appendChild(header);
    var body = el('div', { className: 'fq-coaching__body' });
    body.innerHTML = '<p>' + bodyHtml + '</p>';
    panel.appendChild(body);
    return panel;
  }

  function renderPW101Panel() {
    var panel = el('div', { className: 'fq-coaching' });
    var header = el('div', { className: 'fq-coaching__header' });
    header.appendChild(el('span', { className: 'fq-coaching__header-icon', textContent: '📚' }));
    header.appendChild(el('span', { className: 'fq-coaching__header-title', textContent: 'Pressure Washing 101 — How It All Connects' }));
    panel.appendChild(header);
    var body = el('div', { className: 'fq-coaching__body' });
    body.appendChild(el('p', { innerHTML: 'A pressure washer system has <strong>five key connection points</strong>, each using a specific fitting size. Knowing this helps you buy the right parts.' }));
    body.appendChild(renderSetupChain());
    body.appendChild(el('p', { innerHTML: '<strong>Two sealing systems:</strong> M22 fittings use an internal O-ring — <em>no Teflon tape</em>. NPT fittings use tapered threads — <em>always use Teflon tape or pipe sealant</em>.' }));
    panel.appendChild(body);
    return panel;
  }

  function renderSetupChainPanel(highlightStep) {
    var panel = el('div', { className: 'fq-coaching' });
    var header = el('div', { className: 'fq-coaching__header' });
    header.appendChild(el('span', { className: 'fq-coaching__header-icon', textContent: '🔗' }));
    header.appendChild(el('span', { className: 'fq-coaching__header-title', textContent: 'How a Pressure Washer System Connects' }));
    panel.appendChild(header);
    var body = el('div', { className: 'fq-coaching__body' });
    body.appendChild(renderSetupChain(highlightStep));
    panel.appendChild(body);
    return panel;
  }

  function renderSetupChain(highlightStep) {
    var chain = el('div', { className: 'fq-chain' });

    var steps = [
      { key: 'pump_to_hose',       icon: '🔧', label: 'Pressure Washer',  note: 'Outlet: M22-14mm or M22-15mm' },
      { key: null,                  icon: '↓',  label: '',                  note: '' },
      { key: 'pump_to_hose',       icon: '🟠', label: 'High-Pressure Hose', note: 'Pump end: M22 female or NPT' },
      { key: null,                  icon: '↓',  label: '',                  note: '' },
      { key: 'hose_to_gun',        icon: '🔫', label: 'Spray Gun',         note: 'Pre-gun: 3/8\" QC or M22' },
      { key: null,                  icon: '↓',  label: '',                  note: '1/4\" QC post-gun standard ↓' },
      { key: 'gun_to_wand',        icon: '📏', label: 'Wand / Lance',       note: 'Gun to wand: 1/4\" QC' },
      { key: null,                  icon: '↓',  label: '',                  note: '' },
      { key: 'wand_to_attachment', icon: '💨', label: 'Nozzle / Attachment', note: 'Wand tip: 1/4\" QC' },
    ];

    steps.forEach(function(s) {
      if (!s.label) {
        var arrowRow = el('div', { className: 'fq-chain__arrow', textContent: '↓' });
        chain.appendChild(arrowRow);
        return;
      }
      var isHighlighted = highlightStep && s.key === highlightStep;
      var row = el('div', { className: 'fq-chain__item' + (isHighlighted ? ' fq-chain__item--active' : '') });
      if (isHighlighted) {
        row.style.background = 'rgba(0,166,221,0.08)';
        row.style.borderColor = '#00A6DD';
      }
      row.appendChild(el('span', { className: 'fq-chain__icon', textContent: s.icon }));
      row.appendChild(el('span', { className: 'fq-chain__label', textContent: s.label }));
      if (s.note) row.appendChild(el('span', { className: 'fq-chain__note', textContent: s.note }));
      chain.appendChild(row);
    });

    return chain;
  }

  // =========================================================================
  // RESULT SCREEN
  // =========================================================================
  function renderResult() {
    var wrap = el('div', { className: 'fq-result' });
    var rule = findRule(state.context, state.have_fitting, state.want_fitting);

    wrap.appendChild(renderResultSummary());
    wrap.appendChild(renderResultHeadline(rule));

    if (rule && rule.recommended_skus && rule.recommended_skus.length > 0) {
      var prods = getProductsBySkus(rule.recommended_skus);
      if (prods.length > 0) wrap.appendChild(renderProductList(prods, rule));
    }

    // QC set upsell on direct_fit results
    if (rule && rule.result_type === 'direct_fit' && state.context) {
      var qcSkus = QC_UPSELL_BY_CONTEXT[state.context];
      if (qcSkus && qcSkus.length > 0) {
        var qcProds = getProductsBySkus(qcSkus);
        if (qcProds.length > 0) wrap.appendChild(renderQcUpsell(qcProds));
      }
    }

    if (rule && rule.install_detail) {
      var ib = el('div', { className: 'fq-install-block' });
      ib.appendChild(el('div', { className: 'fq-install-block__label', textContent: '📋 How to install' }));
      ib.appendChild(el('p', { className: 'fq-install-block__text', textContent: rule.install_detail }));
      wrap.appendChild(ib);
    }

    if (rule && rule.warnings && rule.warnings.length > 0) {
      var isNotComp = rule.result_type === 'not_compatible';
      var wb = el('div', { className: 'fq-warnings' + (isNotComp ? ' fq-warnings--danger' : '') });
      wb.appendChild(el('div', { className: 'fq-warnings__label', textContent: isNotComp ? '🚫 Important warnings' : '⚠️ Good to know' }));
      var ul = el('ul', { className: 'fq-warnings__list' });
      rule.warnings.forEach(function(w) { ul.appendChild(el('li', { textContent: w })); });
      wb.appendChild(ul);
      wrap.appendChild(wb);
    }

    wrap.appendChild(renderResultActions());
    wrap.appendChild(renderSupportBlock());
    return wrap;
  }

  function renderResultSummary() {
    var div = el('div', { className: 'fq-result__summary' });
    var hf = FITTINGS[state.have_fitting];
    var wf = FITTINGS[state.want_fitting];

    div.appendChild(el('span', { innerHTML: '<strong>' + getProductLabel(state.have_type) + '</strong>' }));
    if (hf) { div.appendChild(el('span', { textContent: ' with ' })); div.appendChild(el('strong', { textContent: hf.label })); }
    div.appendChild(el('span', { className: 'fq-result__summary-arrow', textContent: ' → ' }));
    div.appendChild(el('span', { innerHTML: '<strong>' + getProductLabel(state.want_type) + '</strong>' }));
    if (wf) { div.appendChild(el('span', { textContent: ' with ' })); div.appendChild(el('strong', { textContent: wf.label })); }

    return div;
  }

  function renderResultHeadline(rule) {
    if (!rule) return renderHeadlineBlock('needs_support','💬','We need a bit more info','Contact our team and we\'ll find the right fitting for you.');
    var configs = {
      direct_fit:        { cls:'direct',   icon:'✅', title:'Direct connection — no adapter needed' },
      adapter_needed:    { cls:'adapter',  icon:'🔩', title:'One adapter will make this connection' },
      multiple_products: { cls:'multiple', icon:'🔩', title:'You\'ll need a couple of parts' },
      not_compatible:    { cls:'no-go',    icon:'🚫', title:'These won\'t connect correctly' },
      possible_match:    { cls:'possible', icon:'⚠️',  title:'Likely match — please verify your fitting size' },
      needs_support:     { cls:'support',  icon:'💬', title:'Our team can confirm this for you' },
    };
    var c = configs[rule.result_type] || configs.needs_support;
    return renderHeadlineBlock(rule.result_type, c.icon, c.title, rule.message);
  }

  function renderHeadlineBlock(resultType, icon, title, message) {
    var clsMap = { direct_fit:'direct', adapter_needed:'adapter', multiple_products:'multiple', not_compatible:'no-go', possible_match:'possible', needs_support:'support' };
    var cls = clsMap[resultType] || 'support';
    var div = el('div', { className: 'fq-result__headline fq-result__headline--' + cls });
    div.appendChild(el('span', { className: 'fq-result__headline-icon', textContent: icon }));
    var text = el('div', { className: 'fq-result__headline-text' });
    text.appendChild(el('h3', { textContent: title }));
    text.appendChild(el('p',  { textContent: message }));
    div.appendChild(text);
    return div;
  }

  function renderProductList(products, rule) {
    var container = el('div', { className: 'fq-product-list' });
    products.forEach(function(product, i) {
      var card = el('div', { className: 'fq-product-card' });

      var imgWrap = el('div', { className: 'fq-product-card__img-wrap' });
      if (product.image) {
        imgWrap.appendChild(el('img', { className: 'fq-product-card__img', src: product.image, alt: product.title, loading: 'lazy' }));
      } else {
        imgWrap.appendChild(el('span', { innerHTML: '🔩', style: 'font-size:2rem;' }));
      }
      card.appendChild(imgWrap);

      var body = el('div', { className: 'fq-product-card__body' });
      body.appendChild(el('div', { className: 'fq-product-card__sku', textContent: product.sku }));
      body.appendChild(el('div', { className: 'fq-product-card__title', textContent: product.title }));
      body.appendChild(el('p',   { className: 'fq-product-card__desc', textContent: product.description }));
      if (rule && rule.install_on && i === 0) {
        body.appendChild(el('div', { className: 'fq-product-card__install', textContent: '📍 Installs on: ' + formatInstallOn(rule.install_on) }));
      }
      var ctaUrl = product.url || ('/products/' + product.handle);
      body.appendChild(el('a', { className: 'fq-btn fq-btn--cta', href: ctaUrl, textContent: 'View Product →', style: 'display:inline-flex;' }));
      card.appendChild(body);
      container.appendChild(card);
    });
    return container;
  }

  function renderResultActions() {
    var div = el('div', { className: 'fq-result__actions' });
    div.appendChild(el_btn('← Start Over',       'fq-btn fq-btn--ghost',   function() { state = buildInitialState(); rerender(); }));
    div.appendChild(el_btn('← Change My Answers', 'fq-btn fq-btn--ghost',  function() { state.screen = 'step'; state.step = 5; rerender(); }));
    return div;
  }

  function renderQcUpsell(products) {
    var panel = el('div', { className: 'fq-qc-upsell' });
    panel.appendChild(el('div', { className: 'fq-qc-upsell__heading', textContent: 'Want to make connecting easier?' }));
    var subP = el('p', { textContent: 'These quick-connect sets work with your connection and make swapping attachments a snap:', style: 'margin: 0 0 0.75rem; font-size: 0.9rem;' });
    panel.appendChild(subP);
    var grid = el('div', { className: 'fq-qc-upsell__grid' });
    products.forEach(function(product) {
      var card = el('a', { className: 'fq-qc-upsell__card', href: product.url || ('/products/' + product.handle) });
      if (product.image) {
        card.appendChild(el('img', { className: 'fq-qc-upsell__card-img', src: product.image, alt: product.title, loading: 'lazy' }));
      }
      var info = el('div');
      info.appendChild(el('div', { className: 'fq-qc-upsell__card-title', textContent: product.title }));
      info.appendChild(el('div', { textContent: product.sku, style: 'font-size:0.75rem;color:#6b7280;margin-top:2px;' }));
      card.appendChild(info);
      grid.appendChild(card);
    });
    panel.appendChild(grid);
    return panel;
  }

  function renderSupportBlock() {
    var div = el('div', { className: 'fq-support-block' });
    div.appendChild(el('p', { className: 'fq-support-block__heading', textContent: 'Still not sure?' }));
    div.appendChild(el('p', { className: 'fq-support-block__text',    textContent: CFG.supportMsg }));
    if (CFG.supportUrl) {
      div.appendChild(el('a', { className: 'fq-btn fq-btn--outline', href: CFG.supportUrl, textContent: CFG.supportLabel }));
    }
    return div;
  }

  // =========================================================================
  // RULES ENGINE
  // =========================================================================
  function findRule(context, haveFitting, wantFitting) {
    var haveF = (haveFitting === 'unknown') ? null : haveFitting;
    var wantF = (wantFitting === 'unknown') ? null : wantFitting;
    var ctx   = (context === 'unknown' || context === 'diagnose') ? null : context;

    var best = null, bestScore = -1;

    RULES.forEach(function(rule) {
      var score = 0;
      if (ctx && rule.context === ctx)           score += 8;
      else if (!ctx && !rule.context)            score += 4;
      else if (ctx && !rule.context)             score += 1;
      else if (!ctx && rule.context)             return;

      if      (haveF && rule.have_fitting === haveF)  score += 4;
      else if (!haveF && rule.have_fitting === 'unknown') score += 2;
      else if (haveF && rule.have_fitting === null)   score += 1;
      else if (haveF && rule.have_fitting !== haveF && rule.have_fitting !== null) return;

      if      (wantF && rule.want_fitting === wantF)  score += 4;
      else if (!wantF && rule.want_fitting === null)  score += 2;
      else if (wantF && rule.want_fitting === null)   score += 1;
      else if (wantF && rule.want_fitting !== wantF && rule.want_fitting !== null) return;

      if (score > bestScore) { bestScore = score; best = rule; }
    });
    return best;
  }

  // =========================================================================
  // SHARED RENDER HELPERS
  // =========================================================================

  function renderProgressBar(current, total, label) {
    var pct = Math.round((current - 1) / total * 100);
    var displayLabel = label;
    if (!displayLabel) {
      if (current === 1) {
        displayLabel = 'What are you connecting?';
      } else if (state.context && CONTEXT_LABELS[state.context]) {
        displayLabel = 'I am trying to connect: ' + CONTEXT_LABELS[state.context];
      } else {
        var stepLabels = { 2:'Your item', 3:'Your fitting', 4:'Target item', 5:'Target fitting' };
        displayLabel = stepLabels[current] || ('Step ' + current);
      }
    }

    var div = el('div', { className: 'fq-progress' });
    var lrow = el('div', { className: 'fq-progress__label' });
    lrow.appendChild(el('span', { className: 'fq-progress__step-text', textContent: displayLabel }));
    lrow.appendChild(el('span', { className: 'fq-progress__count', textContent: 'Step ' + current + ' of ' + total }));
    div.appendChild(lrow);
    var track = el('div', { className: 'fq-progress__track' });
    var fill  = el('div', { className: 'fq-progress__fill' });
    fill.style.width = pct + '%';
    track.appendChild(fill);
    div.appendChild(track);
    return div;
  }

  function renderStepHeader(question, hint) {
    var div = el('div', { className: 'fq-step-header' });
    div.appendChild(el('h3', { className: 'fq-step-header__question', textContent: question }));
    if (hint) div.appendChild(el('p', { className: 'fq-step-header__hint', textContent: hint }));
    return div;
  }

  function renderProductGrid(side, onSelect) {
    var grid = el('div', { className: 'fq-choice-grid' });
    PRODUCT_TYPES.forEach(function(pt) {
      var isSelected = (side === 'have') ? state.have_type === pt.id : state.want_type === pt.id;
      var card = el('div', {
        className: 'fq-choice-card' + (isSelected ? ' is-selected' : ''),
        role: 'button', tabIndex: 0,
      });

      var iconUrl = FQ_ICONS['pt-' + pt.id];
      if (iconUrl) {
        var iw = el('div', { className: 'fq-choice-card__img-wrap' });
        iw.appendChild(el('img', { className: 'fq-choice-card__img', src: iconUrl, alt: pt.label, loading: 'lazy' }));
        card.appendChild(iw);
      } else {
        card.appendChild(el('span', { className: 'fq-choice-card__icon', textContent: pt.emoji }));
      }
      card.appendChild(el('span', { className: 'fq-choice-card__label', textContent: pt.label }));
      card.appendChild(el('span', { className: 'fq-choice-card__sub',   textContent: pt.sub }));

      function go() { onSelect(pt.id); }
      card.addEventListener('click', go);
      card.addEventListener('keydown', function(e) { if(e.key==='Enter'||e.key===' ') go(); });
      grid.appendChild(card);
    });
    return grid;
  }

  function renderFittingGrid(fittingIds, selectedId, onSelect) {
    var grid = el('div', { className: 'fq-fitting-grid' });
    fittingIds.forEach(function(fid) {
      var fitting = FITTINGS[fid];
      if (!fitting) return;
      var isSelected = selectedId === fid;
      var card = el('div', {
        className: 'fq-fitting-card' + (isSelected ? ' is-selected' : ''),
        role: 'button', tabIndex: 0,
      });

      var imgWrap = el('div', { className: 'fq-fitting-card__img-wrap' });
      if (fitting.image) {
        imgWrap.appendChild(el('img', { className: 'fq-fitting-card__img', src: fitting.image, alt: fitting.label, loading: 'lazy' }));
      } else {
        imgWrap.appendChild(el('span', { className: 'fq-fitting-card__img-placeholder', textContent: '🔩' }));
      }
      card.appendChild(imgWrap);
      card.appendChild(el('span', { className: 'fq-fitting-card__label',    textContent: fitting.simple_label || fitting.label }));
      card.appendChild(el('span', { className: 'fq-fitting-card__sublabel', textContent: fitting.label }));
      if (fitting.context_hint) {
        card.appendChild(el('span', { className: 'fq-fitting-card__hint', textContent: fitting.context_hint }));
      }
      if (fitting.badge) {
        card.appendChild(el('span', { className: 'fq-badge fq-badge--' + fitting.badge.type, textContent: fitting.badge.text }));
      }

      function go() { onSelect(fid); }
      card.addEventListener('click', go);
      card.addEventListener('keydown', function(e) { if(e.key==='Enter'||e.key===' ') go(); });
      grid.appendChild(card);
    });
    return grid;
  }

  function renderGenderHelper() {
    var div = el('div', { className: 'fq-help-panel' });
    div.appendChild(el('span', { className: 'fq-help-panel__icon', textContent: '💡' }));
    var body = el('div', { className: 'fq-help-panel__body' });
    body.innerHTML =
      '<strong>Male vs Female?</strong> — ' +
      'A <strong>Male</strong> fitting has threads or a pin on the <em>outside</em> — it goes INTO the other piece. ' +
      'A <strong>Female</strong> fitting has threads or a socket on the <em>inside</em> — the other piece goes INTO it. ' +
      'Not sure? Pick "I\'m Not Sure" and we\'ll show the most likely options.';
    div.appendChild(body);
    return div;
  }

  function renderNav(onBack, onNext) {
    var div = el('div', { className: 'fq-nav' });
    if (onBack) div.appendChild(el_btn('← Back', 'fq-btn fq-btn--ghost', onBack));
    if (onNext) div.appendChild(el_btn('Next →', 'fq-btn fq-btn--primary', onNext));
    div.appendChild(renderResetBtn());
    return div;
  }

  function renderResetBtn() {
    return el_btn('Start Over', 'fq-btn fq-btn--reset', function() {
      state = buildInitialState(); rerender();
    });
  }

  // =========================================================================
  // LOOKUP HELPERS
  // =========================================================================
  function getProductsBySkus(skus) {
    return skus.map(function(sku) {
      return PRODUCTS.find(function(p) { return p.sku === sku; });
    }).filter(Boolean);
  }

  function getFittingsForProduct(productType) {
    return FITTING_OPTIONS_BY_PRODUCT[productType] || FITTING_OPTIONS_BY_PRODUCT.default;
  }

  function getProductLabel(typeId) {
    if (!typeId) return 'item';
    var pt = PRODUCT_TYPES.find(function(p) { return p.id === typeId; });
    return pt ? pt.label : typeId;
  }

  function formatInstallOn(installOn) {
    if (!installOn) return 'the fitting';
    return installOn.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
  }

  // =========================================================================
  // DOM UTILITIES
  // =========================================================================
  function el(tag, props) {
    var node = document.createElement(tag);
    if (!props) return node;
    Object.keys(props).forEach(function(key) {
      if      (key === 'className')    node.className   = props[key];
      else if (key === 'textContent')  node.textContent = props[key];
      else if (key === 'innerHTML')    node.innerHTML   = props[key];
      else                             node.setAttribute(key, props[key]);
    });
    return node;
  }

  function el_btn(text, className, onClick) {
    var btn = el('button', { className: className, textContent: text });
    btn.addEventListener('click', onClick);
    return btn;
  }

  // =========================================================================
  // BOOT
  // =========================================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();